export const CATERING_PATH = 'https://www.ezcater.com/brand/pvt/firehouse-subs';
export const FOUNDATION_PATH =
  'https://firehousesubsfoundation.org/about-us/?utm_source=mobile_app&utm_medium=foundation_link';
export const CAREERS_PATH = 'https://careers.firehousesubs.com';
export const FRANCHISE_PATH = 'https://www.franchising.firehousesubs.com';
export const DONATE_PATH = 'https://firehousesubsfoundation.org/donate/?utm_source=mobile_app&utm_medium=foundation_link';
